import { styled } from 'styled-components';

export const DescriptionContainer = styled.div`
  font-size: 20px;
  display: block;
  max-height: fit-content;
  margin: 10px auto 50px auto;
  text-align: center;
  font-family: 'Roboto', sans-serif;
`;
